const STAGE2_REAL = process.env.REACT_APP_STAGE2_REAL === "true";

let stage2;

if (STAGE2_REAL) {
  stage2 = {
    // Stage 2
    1: {
      id: "ARCHIVE_ROOM",
      label: "Salle des Archives",
      icon: "/assets/s2-p1-room.webp",
      activity: "Recherche de documents",
    },
    2: {
      id: "COGNITIVE_EMPATHY_LAB",
      label: "Laboratoire Empathie Cognitive",
      icon: "/assets/s2-p2-room.webp",
      activity: "Ca réflechit dur ici",
    },
    3: {
      id: "IA_SUPERVISION",
      label: "Salle de Supervision IA",
      icon: "/assets/s2-p3-room.webp",
      activity: "Ca brille !",
    },
    4: {
      id: "OPEN_SPACE",
      label: "Open Space",
      icon: "/assets/s2-p4-room.webp",
      activity: "Bien vérouiller sa session en Open Space!",
    },
    5: {
      id: "PLANNING_ROOM",
      label: "Salle des Plannings",
      icon: "/assets/s2-p5-room.webp",
      activity: "Quelle organisation...",
    },
    6: {
      id: "EXEC_OFFICE",
      label: "Bureau Exécutif",
      icon: "/assets/s2-p6-room.webp",
      activity: "Ca sent le pouvoir",
    }
  }
} else {
  stage2 = null
}

export const ORIGAMI_ROOM_CONFIG = {
  1: {
    // Stage 1
    1: {
      id: "SERVER_ROOM",
      label: "Salle des Serveurs",
      icon: "/assets/s1-p1-room.webp",
      activity: "Rangement de cables",
    },
    2: {
      id: "MEETING_ROOM",
      label: "Salle de réunion",
      icon: "/assets/s1-p2-room.webp",
      activity: "Ouh les jolis carnets",
    },
    3: {
      id: "MD_OFFICE",
      label: "Bureau de M.D",
      icon: "/assets/s1-p3-room.webp",
      activity: "Session vérouillée ?",
    },
    4: {
      id: "SAMIR_OFFICE",
      label: "Bureau de Samir",
      icon: "/assets/s1-p4-room.webp",
      activity: "_. ..- ...",
    },
    5: {
      id: "IT_ROOM",
      label: "Salle technique",
      icon: "/assets/s1-p5-room.webp",
      activity: "Plein de schemas",
    },
    6: {
      id: "RH_OFFICE",
      label: "Bureau des RH",
      icon: "/assets/s1-p6-room.webp",
      activity: "Confidentialité ! ",
    },
  },
  2: stage2
};

export function getOrigamiRoomInfo(stage, variant) {
  const stageConf = ORIGAMI_ROOM_CONFIG[stage];
  if (!stageConf) {
    return {
      id: "UNKNOWN",
      label: "Zone inconnue",
      icon: null,
      activity: "Déplacement en cours…",
    };
  }

  const conf = stageConf[variant];
  if (!conf) {
    return {
      id: "UNKNOWN",
      label: "Zone non assignée",
      icon: null,
      activity: "Déploiement en cours…",
    };
  }

  return conf;
}
